import React from 'react'
import CardDetail from '../Components/CardDetail/CardDetail'
import Footer from '../Components/Footer/Footer'
import Navbar from '../Components/NavBar/NavBar'
function Event() {
  return (
    <div>
      <Navbar />
      <CardDetail />     
      <Footer />
    </div>
  )
}

export default Event
